// "My Activity" — the tester's and developer's own trail (/dashboard/activity-log,
// /developer/activity-log).
//
// Same component and same endpoint as the PM and Admin logs. What a tester or
// developer sees is narrower — their own actions, plus anything recorded against
// a project they're assigned to — and that narrowing happens on the SERVER, so
// there is nothing here to get wrong or to bypass by editing a request.

import PageHeader from "@/components/dashboard/PageHeader";
import AuditLogTable from "@/components/dashboard/AuditLogTable";

export default function MyActivity() {
  return (
    <>
      <PageHeader
        title="My Activity"
        subtitle="What you've done, and what happened on the projects you're on."
      />
      <AuditLogTable
        title="Recent activity"
        subtitle="Your own actions plus everything recorded against your assigned projects."
      />
    </>
  );
}
